import { useTranslation } from 'react-i18next'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import { useGetTelesalesUser } from './hooks/use-get-telesales-user'

const TelesalesWarningMessage = () => {
  const { t } = useTranslation()
  const showTelesalesWarning = useGetTelesalesUser()

  if (showTelesalesWarning) {
    return (
      <Alert severity='warning' sx={{ mb: 3, p: 1 }}>
        <AlertTitle>{t('global.warning')}</AlertTitle>
        {t('telesales.top-bar-warning-message')}
      </Alert>
    )
  }
  return null
}

export default TelesalesWarningMessage
